<template>
  <div>
    <el-card
      shadow="never"
      :body-style="{
        padding: '20px 15px',
      }"
    >
      <div v-if="!isEmpty">
        <Timeline>
          <TimelineItem
            v-for="(item, index) in sampleSendingData"
            :key="index"
            v-bind="item"
          >
            <template #default="{ item }">
              <div class="sample-send__container mt-2 pb-20px">
                <div class="sample-send__head">
                  <div>
                    {{ $l('form_label_scope_of_application') || '适用范围' }}
                  </div>
                  <div>
                    {{
                      $l('form_label_fabric_color_pattern') || '面料颜色或花型'
                    }}
                  </div>
                </div>
                <div class="sample-send__value">
                  <div>
                    <div class="fs-w mb-5px"> {{ $l('form_label_receiving_company') || '收件公司' }}</div>
                    <div class="color-4f mb-10px">
                      {{ item.content.custName }}
                    </div>
                    <div class="fs-w mb-5px"> {{ $l('form_label_recipient') || '收件人' }}</div>
                    <div class="color-4f mb-5px">
                      {{ item.content.consignees }}
                    </div>
                    <div class="color-4f mb-10px">
                      {{ item.content.consigneesPhone }}
                    </div>
                    <div class="fs-w mb-5px">{{ $l('form_label_deliveryAddress') || '收件地址' }}</div>
                    <div class="color-4f mb-10px">
                      {{ item.content.deliveryAddress }}
                    </div>
                    <div class="fs-w mb-5px">{{ $l('form_label_custContactPhone') || '联系方式' }}</div>
                    <div class="color-4f mb-5px">
                      {{ item.content.custContactPhone }}
                    </div>
                    <div class="color-4f mb-10px">
                      {{ item.content.custContactEmail }}
                    </div>
                    <div class="fs-w mb-5px">{{ $l('form_label_deliveryNo') || '物流单号' }}</div>
                    <div class="color-4f mb-5px">
                      {{ item.content.deliveryScmName }}
                    </div>
                    <div class="color-4f">{{ item.content.deliveryNo }}</div>
                  </div>
                  <div class="sample_info__container">
                    <Card
                      v-for="(detail, dIndex) in item.content.sendDetailList"
                      :key="dIndex"
                      v-bind="detail"
                      :cardInfo="{ ...detail }"
                      :deliveryDate="item.content.deliveryDate"
                      :signDate="item.content.signDate"
                    />
                  </div>
                </div>
              </div>
            </template>
          </TimelineItem>
        </Timeline>
      </div>
      <div v-else class="not-data__container">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import Timeline from '../timeline/index.vue'
import TimelineItem from '../timeline/item.vue'
import Card from './card.vue'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [EditLoading],

  props: {
    devTrackingCode: { type: String, default: '' },
  },
  components: { Timeline, TimelineItem, Card },
  mounted() {
    this.getData()
  },
  data() {
    return {
      sampleSendingData: [],
    }
  },
  computed: {
    isEmpty() {
      return !this.sampleSendingData || !this.sampleSendingData.length
    },
  },
  methods: {
    getData() {
      if (!this.devTrackingCode) return
      if (this.loadingOpen()) return
      this.$api
        .masterCustomerDevTrackingSendListApi({
          devTrackingCode: this.devTrackingCode,
        })
        .then((res) => {
          this.loadingClose()
          const list = res.body.data || []

          this.sampleSendingData = list.map((m) => {
            m.type = 'S'
            m.title = `${this.$l('form_label_sendSampleNo') || '寄样单号'}：${
              m.sendSampleNo
            }`
            m.time = m.createDate
            m.name = m.createByName
            m.content = { ...m }
            return m
          })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.sample-send__container {
  .sample-send__head {
    display: flex;
    font-size: 13px;
    align-items: center;
    div {
      padding: 10px;
      display: flex;
      background-color: #fafafa;
      color: #303133;
      border: 1px solid #efefef;
    }
    > div:first-child {
      width: 240px;
    }
    > div:last-child {
      border-left: none;
      flex: 1;
    }
  }
  .sample-send__value {
    display: flex;
    font-size: 13px;
    > div {
      display: flex;
      border: 1px solid #efefef;
    }
    > div:first-child {
      padding: 10px;
      width: 240px;
      border-top: none;
      background-color: white;
      flex-direction: column;
    }
    > div:last-child {
      padding: 10px 0;
      border-left: none;
      border-top: none;
      background-color: #efefef;
      flex: 1;
    }
    .sample_info__container {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }
}
.not-data__container {
  height: 500px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fs-w {
  color: #4f4f4f;
  font-weight: 600;
  font-size: 14px;
}
.color-4f {
  color: #4f4f4f;
}
.mb-5px {
  margin-bottom: 5px;
}
.mb-10px {
  margin-bottom: 10px;
}
.mr-3px {
  margin-right: 3px;
}
.pb-20px {
  padding-bottom: 20px;
}
.label-key {
  color: #6c757d;
  font-weight: 600;
}
.fs-18 {
  font-size: 18px;
}
.color-blue {
  color: #007bff;
}
.fs-12 {
  font-size: 12px;
}
.fs-600w {
  font-weight: 600;
}
</style>
